/* eslint-disable @typescript-eslint/member-ordering */
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PersonDTO } from 'app/consulta-mark-list/interface/personDTO';
import {
  PayloadTemporaryUnlockDTO,
  TemporaryUnlockDTO,
} from 'app/consulta-mark-list/interface/temporaryUnlockDTO';
import { InfoClienteService } from 'app/consulta-mark-list/service/BehaviorSubject/infoClient.service';
import { ConsultaMarkListService } from 'app/consulta-mark-list/service/consulta-mark-list.service';
import { CountriesService as CountriesServiceMarklist } from 'app/service/countries.service';

import { CountryService } from 'shared-angular-components-avla/country/country.service';
import {
  AvlaGenericComponent,
  I18nService,
  InfoMessageDTO,
  MessageService,
} from 'shared-angular-components-avla';
import { CountriesService } from 'services-sc-component';
import {
  AuthService,
  AvlaRestClientService,
  SearchInAttributeDTO,
} from 'base-angular-avla';
import moment from 'moment/moment';

@Component({
  selector: 'ml-unlock-temporarily-panel',
  templateUrl: './ml-unlock-temporarily.component.html',
  styleUrls: ['./ml-unlock-temporarily.component.css'],
  providers: [CountryService],
})
export class MlUnlockTemporarilyComponent
  extends AvlaGenericComponent
  implements OnInit, OnDestroy
{
  constructor(
    protected avlaRestClient: AvlaRestClientService,
    protected messageService: MessageService,
    protected router: Router,
    protected authService: AuthService,
    protected marklistService: ConsultaMarkListService,
    protected infoClientSubjectService: InfoClienteService,
    public countriesService: CountriesService,
    protected i18n: I18nService,
    protected countryService: CountryService,
    protected formBuilder: FormBuilder,
    protected countriesServiceMarklist: CountriesServiceMarklist
  ) {
    super(avlaRestClient, messageService, router, authService, i18n);
  }

  @ViewChild('unlockModal', { static: true }) unlockModal: any;
  @Input() person: PersonDTO;
  @Output() sendUnlockData: EventEmitter<any> = new EventEmitter();

  reactiveForm: FormGroup;
  timeRemaining: string | null = null;
  intervalId: any;
  loading = false;
  cdCountry: string;
  minDate: string;
  maxDate: string;
  businessDays: moment.Moment[] = [];
  showFieldDate = false;

  ngOnInit(): void {
    if (this.person) {
      this.startCountdown();
    }
    this.countryService.countryChanged.subscribe(temp => {
      if (temp !== this.cdCountry) {
        this.cdCountry = temp;
      }
    });
    if (null !== this.countryService.getCurrentSelectedCountry()) {
      const selectedCdCountry =
        this.countryService.getCurrentSelectedCountry().isoCode;
      if (selectedCdCountry !== this.cdCountry) {
        this.cdCountry = selectedCdCountry;
      }
    }
    this.createForm();
    this.setDateConstraints();
  }

  createForm() {
    this.reactiveForm = this.formBuilder.group({
      temporaryUnlockedUntil: [null, Validators.required],
      cdCountry: [null],
      unlockReason: [null, Validators.required, Validators.maxLength[800]],
    });
  }

  confirmSwitchUnlock() {
    this.loading = true;
    // Validacion para bloquear nuevamente: eliminar los campos requeridos del formulario
    if (this.person.isTemporarilyUnlocked) {
      ['temporaryUnlockedUntil', 'unlockReason'].forEach(control => {
        this.reactiveForm.controls[control].clearValidators();
        this.reactiveForm.controls[control].updateValueAndValidity();
      });
    }
    // Obtener error de fecha menor a la actual
    const errorDate = this.reactiveForm
      .get('temporaryUnlockedUntil')
      .hasError('invalidBusinessDay');
    if (errorDate) {
      this.loading = false;
      this.reactiveForm.markAllAsTouched();
      return;
    }
    // Añade 3 horas a la fecha actual si no se le especifica una fecha especifica
    const temporaryUnlockedUntil = this.showFieldDate
      ? this.reactiveForm.get('temporaryUnlockedUntil').value
      : moment().add(3, 'hours').format('YYYY-MM-DD HH:mm:ss');
    this.reactiveForm.controls['temporaryUnlockedUntil'].setValue(
      temporaryUnlockedUntil
    );
    // Si el formulario no es válido, marcar todos los campos como tocados y salir de la función
    if (this.reactiveForm.invalid) {
      this.loading = false;
      this.reactiveForm.markAllAsTouched();
      return;
    }

    // Obtener el valor del formulario y formatear la fecha
    const form: PayloadTemporaryUnlockDTO = this.reactiveForm.getRawValue();
    const temporaryUnlockedUntilFormat = moment(form.temporaryUnlockedUntil)
      .utc()
      .format('YYYY-MM-DDTHH:mm:ss');
    // Crear el payload para enviar
    const payload: PayloadTemporaryUnlockDTO = {
      ...form,
      temporaryUnlockedUntil: temporaryUnlockedUntilFormat,
      personId: this.person.idPerson,
      cdCountry: this.cdCountry,
    };
    this.marklistService.switchTemporaryUnlockInfo(payload).subscribe(
      data => {
        if (this.errorInResponse(data)) {
          this.loading = false;
          return;
        }
        const searchFilter = new SearchInAttributeDTO();
        searchFilter.attributeNames = ['idPerson'];
        searchFilter.value = this.person.idPerson.toString();
        searchFilter.comparator = 'contains';
        this.unlockDataPersona(data, searchFilter);
      },
      error => {
        this.routeAccordingError(error);
        this.loading = false;
        this.unlockModal.hide();
      }
    );
  }

  unlockDataPersona(
    data: TemporaryUnlockDTO,
    searchFilter: SearchInAttributeDTO
  ) {
    this.marklistService
      .getPersonListPaginated(
        1,
        0,
        '',
        encodeURIComponent(JSON.stringify(searchFilter))
      )
      .subscribe(
        response => {
          if (this.errorInResponse(response)) {
            this.loading = false;
            return;
          }
          if (response.data && response.data.length) {
            const person = response.data.find(
              (persona: PersonDTO) => persona.idPerson === data.personId
            );
            this.loading = false;
            this.sendUnlockData.emit(person);
            this.unlockModal.hide();
          }
        },
        error => {
          this.messageService.announcedMessage(
            new InfoMessageDTO(
              'danger',
              'No se ha podido realizar la operación. Intente nuevamente',
              AvlaGenericComponent.TIME_NOTIFICATION
            )
          );
          this.routeAccordingError(error);
          this.loading = false;
          return;
        }
      );
  }

  private startCountdown(): void {
    let timeDiff = this.calculateTimeDiff(this.person.unlockedUntil);
    this.timeRemaining = this.formatTime(timeDiff);
    if (this.person.isTemporarilyUnlocked) {
      this.intervalId = setInterval(() => {
        timeDiff = this.calculateTimeDiff(this.person.unlockedUntil);
        this.timeRemaining = this.formatTime(timeDiff);

        if (timeDiff <= 0) {
          this.loader.view = false;
          clearInterval(this.intervalId);
        }
      }, 1000);
    }
  }

  private calculateTimeDiff(unlockedTime) {
    const now = new Date().getTime();
    const unlockTime = new Date(unlockedTime).getTime();
    return unlockTime - now;
  }

  private formatTime(timeDiff: number): string {
    const padZero = (num: number) => num.toString().padStart(2, '0');

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    const formattedTime = `${padZero(hours)}h ${padZero(minutes)}m ${padZero(
      seconds
    )}s`;
    return days > 0 ? `${days}d ${formattedTime}` : formattedTime;
  }

  private canUnlockTemporarily(): boolean {
    return this.authService.isAllowedHtmlElement(
      52587,
      'REST_POST_switchTemporaryUnlock'
    );
  }

  private setDateConstraints() {
    const today = moment();
    this.businessDays = this.getNextBusinessDays(today, 7);

    this.minDate = moment().format('YYYY-MM-DDTHH:mm');
    this.maxDate = this.businessDays[6].format('YYYY-MM-DDTHH:mm');
  }

  private getNextBusinessDays(
    startDate: moment.Moment,
    numberOfDays: number
  ): moment.Moment[] {
    const businessDays: moment.Moment[] = [];
    const currentDate = startDate.clone();

    while (businessDays.length < numberOfDays) {
      currentDate.add(1, 'days');
      businessDays.push(currentDate.clone());
    }
    return businessDays;
  }

  private validateDate(value: string) {
    const selectedDate = moment(value);
    const now = moment();
    // Validar hora menor a la actual
    const isToday = selectedDate.isSame(now, 'day');
    // Fecha menor a la actual
    const isBeforeToday = selectedDate.isBefore(now, 'day');
    // Fecha mayor a los 7 dias habiles
    const isAfterMaxDate = selectedDate.isAfter(this.businessDays[6]);
    // eslint-disable-next-line prettier/prettier
    if (
      isBeforeToday ||
      (isToday && selectedDate.isBefore(now)) ||
      isAfterMaxDate
    ) {
      this.reactiveForm
        .get('temporaryUnlockedUntil')
        .setErrors({ invalidBusinessDay: true });
    } else {
      this.reactiveForm.get('temporaryUnlockedUntil').setErrors(null);
    }
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
